import React from 'react';
import { connect } from 'react-redux';
import './style.scoped.scss';
import Login from '../../components/Account/Login';
import { ROUTES } from '../../assets/constants/strings';
import AccountPagesWrapper from '../../components/Account/PageWrapper';
import { Redirect } from 'react-router-dom';

const LoginPage = ({ user, loading }) => {
  if (user && user.token && user.isActive) {
    return <Redirect to={ROUTES.HOME} />;
  } else if (user && user.token && !user.isActive) {
    return <Redirect to={ROUTES.SELECT_PLANS} />;
  }
  // if user is Admin 1WordFlow
  // else if (user?.isSuperAdmin) {
  //   return <Redirect to={ROUTES.HOME} />;
  // }
  // has not yet logged in
  else
    return (
      <AccountPagesWrapper>
        <div className='wf-account__card login'>
          <Login />
        </div>
      </AccountPagesWrapper>
    );
};

const mapStateToProps = (state) => ({
  userPlan: state.user.userPlan,
  user: state.user.user,
  loading: state.user.loading,
});


export default connect(mapStateToProps, {})(LoginPage);
